<!-- Main Content Card -->
<div class="content-card">
  <div class="card-header">
    <h3 class="card-title">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
        <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
        <path d="M10 9H8"></path>
        <path d="M16 13H8"></path>
        <path d="M16 17H8"></path>
      </svg>
      Contract Management
    </h3>
  </div>

  <div class="card-content">
    <div class="table-wrapper">
      <table class="contracts-table">
        <thead>
          <tr>
            <th>Customer ID</th>
            <th>Name - Address</th>
            <th>Voucher</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (customer of customers; track customer) {
            <tr>
              <td data-label="Customer ID">{{ customer.id }}</td>
              <td data-label="Name - Address">{{ customer.name }}</td>
              <td data-label="Voucher">{{ customer.voucher }}</td>
              <td data-label="Status">{{ customer.status }}</td>
              <td data-label="Action">
                <button class="view-btn" type="button" (click)="viewContract(customer.contract)">
                  View
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (pdfVisible) {
      <div class="pdf-container">
        <iframe [src]="pdfUrl" width="100%" height="100%"></iframe>
      </div>
    }
  </div>
</div>
